export const fonts = {
  display: "'Cormorant Garamond', serif",
  body:    "'DM Sans', sans-serif",
  script:  "'Lora', serif",
}

export const THEMES = {
  florece: {
    cream: '#FAF6EE', paper: '#FDF9F2', ink: '#2A2018', inkMid: '#6A5848',
    inkLight: '#A89078', blush: '#F0C4A8', terra: '#C8784E', terraDeep: '#9E5830',
    sage: '#8EAA7A', sagePale: '#C4D8B4', gold: '#C8A04A', goldPale: '#EED898',
    sky: '#98B4C8', lav: '#B4A8C8', mauve: '#C89898',
    cardGradient: 'linear-gradient(135deg, #9E5830, #C8784E, #D4896A)',
    navBg: 'rgba(250,246,238,0.94)', navBorder: 'rgba(200,160,130,0.15)',
    accent: '#C8784E', accentDeep: '#9E5830',
    txBorder: 'rgba(200,160,130,0.12)', txIconBg: '#FDE8D8',
    cardBorder: 'rgba(200,160,130,0.2)', inputBg: 'rgba(255,252,245,0.9)',
  },
  sage: {
    cream: '#F2F5EE', paper: '#F7FAF4', ink: '#1E2A1A', inkMid: '#4A6040',
    inkLight: '#7A9870', blush: '#B4D4A0', terra: '#5A8A4A', terraDeep: '#3A6A2A',
    sage: '#8EAA7A', sagePale: '#C4D8B4', gold: '#C8A04A', goldPale: '#EED898',
    sky: '#7AB4A0', lav: '#A8C4B4', mauve: '#A8C8A0',
    cardGradient: 'linear-gradient(135deg, #3A6A2A, #5A8A4A, #7AAA60)',
    navBg: 'rgba(242,245,238,0.94)', navBorder: 'rgba(90,138,74,0.15)',
    accent: '#5A8A4A', accentDeep: '#3A6A2A',
    txBorder: 'rgba(90,138,74,0.12)', txIconBg: '#D0EAC0',
    cardBorder: 'rgba(90,138,74,0.2)', inputBg: 'rgba(247,250,244,0.9)',
  },
  dark: {
    cream: '#1A1410', paper: '#221C16', ink: '#F5EDE4', inkMid: '#C8B8A8',
    inkLight: '#8A7868', blush: '#3A2A20', terra: '#E8905A', terraDeep: '#C8704A',
    sage: '#7AAA68', sagePale: '#2A3A22', gold: '#E8C06A', goldPale: '#3A3020',
    sky: '#7A9EB8', lav: '#9A90C0', mauve: '#C0909A',
    cardGradient: 'linear-gradient(135deg, #C8704A, #E8905A, #F0A870)',
    navBg: 'rgba(26,20,16,0.97)', navBorder: 'rgba(232,144,90,0.15)',
    accent: '#E8905A', accentDeep: '#C8704A',
    txBorder: 'rgba(232,144,90,0.12)', txIconBg: '#3A2820',
    cardBorder: 'rgba(232,144,90,0.2)', inputBg: 'rgba(34,28,22,0.9)',
  },
  beige: {
    cream: '#F5F0E8', paper: '#FAF7F2', ink: '#3A3028', inkMid: '#7A6A58',
    inkLight: '#B0A090', blush: '#E8D8C4', terra: '#A87850', terraDeep: '#886038',
    sage: '#98A888', sagePale: '#D0DAC8', gold: '#C09840', goldPale: '#E8D890',
    sky: '#9AB0C0', lav: '#B0A8C0', mauve: '#C0A8A8',
    cardGradient: 'linear-gradient(135deg, #886038, #A87850, #C09068)',
    navBg: 'rgba(245,240,232,0.94)', navBorder: 'rgba(168,120,80,0.15)',
    accent: '#A87850', accentDeep: '#886038',
    txBorder: 'rgba(168,120,80,0.12)', txIconBg: '#EDE0CC',
    cardBorder: 'rgba(168,120,80,0.2)', inputBg: 'rgba(250,247,242,0.9)',
  },
}

export const THEME_LABELS = {
  florece: 'Florece Classic',
  sage:    'Sage Calm',
  dark:    'Dark Luxe',
  beige:   'Beige Minimal',
}
